import { z } from "zod";

import { fusionMachineSchema } from "./fusion";
import { trackSchema } from "./track";

export const fusionServiceMachineSchema = fusionMachineSchema.merge(
	z.object({
		tracks: z.array(trackSchema).optional(),
		rollerTools: z.array(z.number()).optional(),
		activeCrossHeadCut: z.boolean().optional(),
		activeCrossHeadLatch: z.boolean().optional(),
		brakeTools: z.array(z.number()).optional(),
	}),
);

export type FusionServiceMachine = z.infer<typeof fusionServiceMachineSchema>;
